import type { ReactElement } from "react";
import { useMemo } from "react";

import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type { LegacyIndustryFilterValueType } from "app/pages/sales-intelligence/modules/leads-search-filters/models/LegacyIndustryFilter/types";

import { MAX_CHIPS_GROUP_AMOUNT } from "../../../constants";
import type LegacyIndustryFilterModel from "../../../models/LegacyIndustryFilter/LegacyIndustryFilterModel";
import industryFilterTrackingService from "../../../services/tracking/industry-filter/trackingService";

import type { IIndustryChipItem } from "./types";
import createIndustryChipItems from "./utils/createIndustryChipItems";

/** @deprecated Result chips for the legacy industry filter (SI-8780). */
const LegacyIndustryFilterResult = ({
    value = {} as LegacyIndustryFilterValueType,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<LegacyIndustryFilterModel>): ReactElement | null => {
    const { selectedIndustries } = value;

    const chipItems: IIndustryChipItem[] = useMemo(() => {
        return createIndustryChipItems(selectedIndustries, "industry", onGetLifecycleStatus);
    }, [selectedIndustries, onGetLifecycleStatus]);

    if (!chipItems.length) {
        return null;
    }

    const handleClose = (_: string, item: IIndustryChipItem) => {
        const newValue = {
            ...value,
            selectedIndustries: selectedIndustries.filter((industry) => industry !== item.id),
        };

        industryFilterTrackingService.trackIndustryRemove(item.id);
        onFilterUpdate(newValue);
        onFilterValueRemove?.(newValue);
    };

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleClose}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default LegacyIndustryFilterResult;
